import * as Yup from 'yup';

import { getPasswordRules, validatePassword } from 'utils/passwordRules';

const createPasswordSchema = (t, { email, mobilePhoneNumber }) =>
  Yup.object({
    password: Yup.string()
      .required(t('createPassword.errors.passwordRequired'))
      // .matches(PASSWORD_REGEX, t('createPassword.errors.invalidPassword'))
      .test('password-validations', t('createPassword.errors.invalidPassword'), function(value) {
        return validatePassword(value, { email, mobilePhoneNumber }, getPasswordRules(t));
      }),
    confirmPassword: Yup.string()
      .required(t('createPassword.errors.confirmPasswordRequired'))
      .oneOf([Yup.ref('password'), null], t('createPassword.errors.confirmPasswordMismatch')),
  });

export default createPasswordSchema;
